"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgCouplesSelected = function SvgCouplesSelected(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m24.124 8.153.018.008v-.015c.406-.172 4.106-1.814 4.106-4.57 0-2.917-2.423-2.562-2.423-2.562s-1.18.132-1.701 1.137c-.522-1.005-1.7-1.137-1.7-1.137S20 .659 20 3.575c0 2.757 3.7 4.399 4.106 4.57v.016l.018-.008Z",
    fill: "#fff",
    stroke: "url(#couples-selected_svg__a)",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.469 33.613H35.562h7.494v15.78s1.04 2.494-.808 2.494c-1.85 0-2.233-2.5-2.233-2.5V33.612h-1.413v15.78s-.245 2.494-2.23 2.494c-1.985 0-.81-2.495-.81-2.495V33.613h-3.254l1.849-13.74-7.12 10.194s.336-.351-.093-1.093c-.428-.741-1.54-1.732-1.54-1.732s5.782-8.274 7.904-11.181c2.122-2.908 4.323-3.03 6.483-3.06 2.16-.03 5.503.438 6.495 3.762.993 3.324 2.642 11.817 2.642 11.817s2.313 2.848.562 3.44c-1.752.59-3.694-2.057-3.694-2.057l-1.864-10.398 2.537 14.048Z",
    fill: "#fff",
    stroke: "url(#couples-selected_svg__b)",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.04 30.574s0-1.237.782-1.237c.78 0 .813 1.237.813 1.237v18.357s.215 2.228 2.562 2.228c2.348 0 1.388-2.228 1.388-2.228V20.807l4.947 7.417s2.902 3.31 4.846 2.405c1.945-.905-.93-3.326-.93-3.326s-6.1-8.459-7.938-11.031c-1.838-2.573-2.117-2.26-4.875-2.26H8.92c-2.105 0-4.211 1.172-4.423 6.02-.212 4.849-.958 13.392-.958 13.392s-1.346 2.646.67 2.687c2.018.04 2.832-2.12 2.832-2.12l.568-4.093.42-9.866-.42 9.866-.568 4.094L5.136 48.69s-.985 2.47 1.325 2.47 2.593-2.23 2.593-2.23l1.987-18.356Z",
    fill: "#fff",
    stroke: "url(#couples-selected_svg__c)",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8 12.6a4.8 4.8 0 1 0 0-9.6 4.8 4.8 0 0 0 0 9.6Z",
    fill: "#fff",
    stroke: "url(#couples-selected_svg__d)",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8 11.6a4.8 4.8 0 1 0 0-9.6 4.8 4.8 0 0 0 0 9.6Z",
    fill: "#fff",
    stroke: "url(#couples-selected_svg__e)",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.642 7.2s3.079.543 3.629 5.08C44.796 13.57 42.5 9.896 42.5 9.896s.405-.476.692-1.16c.288-.686.45-1.536.45-1.536Z",
    fill: "#fff",
    stroke: "url(#couples-selected_svg__f)",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.695 7S30.55 7.613 30 12.15c2.474 1.289 4.883-2.28 4.883-2.28s-.399-.507-.75-1.18c-.35-.674-.438-1.69-.438-1.69Z",
    fill: "#fff",
    stroke: "url(#couples-selected_svg__g)",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "couples-selected_svg__a",
    x1: 28.248,
    y1: 8.161,
    x2: 28.248,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2080F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "couples-selected_svg__b",
    x1: 50.244,
    y1: 51.887,
    x2: 50.244,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2080F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "couples-selected_svg__c",
    x1: 27.163,
    y1: 51.159,
    x2: 27.163,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2080F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "couples-selected_svg__d",
    x1: 17.6,
    y1: 12.6,
    x2: 17.6,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2080F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "couples-selected_svg__e",
    x1: 43.6,
    y1: 11.6,
    x2: 43.6,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2080F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "couples-selected_svg__f",
    x1: 42.5,
    y1: 12.615,
    x2: 42.5,
    y2: 7.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2080F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "couples-selected_svg__g",
    x1: 34.883,
    y1: 12.492,
    x2: 34.883,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2080F1"
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgCouplesSelected);
var _default = exports["default"] = Memo;